type Props = {
  count?: number;
  children: (index: number) => React.ReactNode;
};

const SkeletonList = ({ count = 3, children }: Props) => {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => children(i))}
    </>
  );
};

export default SkeletonList;